export default __webpack_public_path__ + "static/media/book-nav-icon-6.0094995c.svg";